import ReactDOM from 'react-dom/client'
import App from './App'
import './assets/css/index.css'
import 'leaflet/dist/leaflet.css'
import { loadConfig } from 'config'

loadConfig().then((config) => {
  localStorage.setItem('./config', JSON.stringify(config))

  const root = ReactDOM.createRoot(document.getElementById('root')!)
  root.render(<App />)
})
